/**
 * SALES objective — Performance Max campaigns. Pages in this folder:
 * SalesPage (workspace), SalesCampaignWizard, CreateSalesAssetGroup.
 * (PMAX has asset groups instead of ad groups + ads.) The shared editors,
 * previews and publish helpers live in src/components/google-ads/performance-max/.
 */
import { Tag } from 'lucide-react';
import { PmaxObjectiveConfig } from '@/components/google-ads/performance-max/pmaxShared';

export const SALES_BASE = '/google-ads/sales';

export const SALES_OBJECTIVE: PmaxObjectiveConfig = {
  key: 'sales',
  title: 'Sales',
  base: SALES_BASE,
  subtitle: 'Performance Max — one campaign that sells across Search, YouTube, Display, Gmail, Discover and Maps',
  icon: Tag,
  storeGoals: false,
  goal: 'Online sales, leads and conversions',
  namePrefix: 'PMax - Sales',
  emptyHint: 'Give Google your text, images and videos once — Performance Max builds every ad format and finds buyers across all of Google.',
};
